<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form lg:tw-mx-auto" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
                <h1>Meld u aan om uw aanbieding te ontvangen <br class="tw-hidden lg:tw-block">Black Friday-voorproefje</h1>
            </div>
            <fieldset class="tw-px-3 tw-pb-3 lg:tw-px-12 lg:tw-pb-12">

                <!-- Form radio buttons -->
                <div class="radios-container tw-grid tw-grid-cols-1 tw-gap-3 lg:tw-gap-4 tw-pb-4">
                    <div class="tw-flex tw-flex-row tw-gap-6">
                        <label class="radio tw-relative tw-pl-8" @click="country = 'FR'" :class="{ 'active' : country == 'FR' }">
                            <span class="tw-text-black tw-text-sm">Français</span>
                        </label>
                        <label class="radio tw-relative tw-pl-8" @click="country = 'NL'" :class="{ 'active' : country == 'NL' }">
                            <span class="tw-text-black tw-text-sm">Néerlandais</span>
                        </label>
                    </div>
                    <div class="tw-flex tw-flex-row tw-gap-6">
                        <label class="radio tw-relative tw-pl-8" @click="gender = 'Ms'" :class="{ 'active' : gender == 'Ms' }">
                            <span class="tw-text-black tw-text-sm">Mevr</span>
                        </label>
                        <label class="radio tw-relative tw-pl-8" @click="gender = 'Mr'" :class="{ 'active' : gender == 'Mr' }">
                            <span class="tw-text-black tw-text-sm">Dhr</span>
                        </label>
                    </div>
                </div>

                <!-- Form input fields -->
                <div class="tw-flex tw-flex-col">
                    <validation-provider class="tw-w-full tw-w-block" name="lastName" rules="required" v-slot="{ classes }">
                        <div class="input-group input-group-name tw-mb-2" :class="classes">
                            <input type="text"
                                id="input-lastName"
                                placeholder=" "
                                v-model="lastName"
                            >
                            <label>
                                Voornaam
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="firstName" rules="required" v-slot="{ classes }">
                        <div class="input-group input-group-name tw-mb-2" :class="classes">
                            <input type="text"
                                id="input-firstName"
                                placeholder=" "
                                v-model="firstName"
                            >
                            <label>
                                Achternaam
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'invalide' }">
                        <div class="input-group input-group-email tw-mb-2" :class="classes">
                            <input type="email"
                                id="input-email"
                                placeholder=" "
                                v-model.lazy="email"
                            >
                            <label>
                                E-mailadres {{ errors [0]}}
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="birthdate" v-slot="{ classes }">
                        <div class="input-group input-group-birthdate" :class="classes">
                            <input type="tel"
                                id="input-birthdate"
                                placeholder=" "
                                v-model="birthdate"
                                v-mask="{alias: 'datetime', inputFormat: 'dd/mm/yyyy', placeholder: 'DD/MM/YYYY', showMaskOnHover: false, showMaskOnFocus: true}"
                            >
                            <label>
                                Geboortedatum
                            </label>
                        </div>
                    </validation-provider>
                </div>

                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="tw-pt-4">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span class="tw-text-black">Ik aanvaard dat mijn e-mailadres zal gebruikt worden om mij nieuws, persoonlijke aanbiedingen, en avant-premières van Clarins te sturen conform het Clarins <a href="#" @click.prevent="$store.state.modal.terms = true"><u>privacybeleid</u></a> die de bescherming van de persoonsgegevens waarborgt.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>

                <div class="tw-text-center tw-mt-4">
                    <button
                        type="submit"
                        class="btn-cta tw-tracking-widest"
                        id="submit"
                        :disabled="formLoading"
                    >
                        Registreer gratis
                    </button>
                </div>
            </fieldset>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            gender: 'Mme',
            country: 'NL',
            firstName: '',
            lastName: '',
            birthdate: '',
            email: '',
            unsub: 0,
            pubid: this.$route.query.pubid || '',

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            var action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;

            if (window.location.host.split('.')[0] === 'nl') {
                action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/nl_clarinsbnl_com`;
            }

            let cmpInfo = {
                vendor:{
                    consents: [],
                },
                tcString: '',
            };

            try{
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const data = {
                pubid: this.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                gender: this.gender,
                country: this.country,
                firstName: this.firstName,
                lastName: this.lastName,
                birthdate: this.birthdate,
                email: this.email,
                unsub: this.unsub,

                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
                mclic: process.env.VUE_APP_MCLIC,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'déjà enregistré';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
// @import '~@/assets/scss/partials/_fonts.scss';

@font-face {
    font-family: 'Clarins';
    src: url('../assets/fonts/Clarins-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
}

.form {
    @apply tw-px-3;

    @screen xl {
        @apply tw-px-5;
    }

    .form-title {

        h1 {
            font-family: 'Clarins';
            color: $main_color;
            font-size: 22px;
            line-height: 32px;
            padding-bottom: 36px;

            @screen lg {
                font-size: 26px;
                line-height: 32px;
                padding-bottom: 36px;
            }
        }
    }

    fieldset {

        .radios-container {

            label.radio {
                @apply tw-relative tw-transition-all;

                &::before {
                    content: '';
                    @apply tw-rounded-full tw-absolute tw-left-0 tw-top-0 tw-transition-all;
                    border: solid 1px #000;
                    width: 20px;
                    height: 20px;
                }

                &.active {

                    &::before {
                        border-color: $main_color;
                        background-color: $main_color;
                    }
                }
            }
        }
    }
}
</style>
